import { hasImpersonationTokens, hasTokens } from '@/shared/auth/user-store';
import { useImpersonate, useLogin, useLogout, useUser } from '@/shared/user/queries';

/**
 * A custom hook that provides authentication logic and state management.
 *
 * @return An object containing properties and methods related to auth.
 */
export function useAuth() {
  const user = useUser();
  const login = useLogin();
  const logout = useLogout();
  const impersonate = useImpersonate();

  const isAuthenticated = hasTokens() && !user.isError;
  const isLoading = user.isLoading || login.isPending;
  const isImpersonating = hasImpersonationTokens();

  return {
    user,
    isAuthenticated,
    isLoading,
    isImpersonating,
    isError: user.isError || login.isError,
    error: user.error || login.error,
    login,
    logout,
    impersonate
  };
}
